import { Checkbox } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';


export default class ListaEvaluatoriAll extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }
    render() {
        return (
            <ul className='evaluari-departamente'>
                {this.props.listaDepartamente.map((l, idx) => {


              
                       
                            return (
                                <li className='evaluari-departament' key={idx}>
                                    <div className='evaluari-departament-nume-line'>
                                        <div>
                                            {l.selectat ?
                                                <i onClick={() => { this.props.selecteazaDepartament(l) }} style={{ color: '#80cd5a' }} className='material-icons checkbox-departament' >check_box</i>
                                                : <i onClick={() => { this.props.selecteazaDepartament(l) }} className='material-icons checkbox-departament' >check_box_outline_blank</i>
                                            }

                                            <span> Departament {l.nume}</span>
                                        </div>
                        

                                    </div>

                                
                                        <div>
                                            <ul className='evaluari-angajati'>
                                                {l.angajati && l.angajati.map((a, idx2) => {
                                                    return (<li className='evaluari-departament' key={idx2}>
                                                        <div>
                                                            {a.selectat ?
                                                                <i onClick={() => { this.props.selecteazaAngajat(a) }} style={{ color: '#80cd5a' }} className='material-icons checkbox-departament' >check_box</i>
                                                                : <i onClick={() => { this.props.selecteazaAngajat(a) }} className='material-icons checkbox-departament' >check_box_outline_blank</i>
                                                            }

                                                            <span>{a.nume}</span>
                                                        </div>
                                                    </li>)
                                                })}

                                            </ul>
                                        </div>
                                    

                                </li>
                            )

                        
                 

                })}



            </ul>
        );
    }
}